import { PageHeader, Space } from 'antd';
import { useContext, useEffect } from 'react';
import { Filters, IssueDetail, IssuesTable } from './components';
import { IssuesContext } from './context/issues.context';

const Issues = () => {
    const {
        loading,
        data,
        item,
        total,
        paginator,
        fetchData,
        onPageChange,
        searchParams,
        setSearchParams,
        startDate,
        endDate,
        setItem,
        fetchItem,
        handleDate,
        handleIssueId,
        handleBooking,
        handleWorkspace,
        handleStatus,
        handleUnRead,
        handleType,
    } = useContext(IssuesContext);

    const open = searchParams.get('open');

    useEffect(() => {
        if (open) {
            fetchItem(open);
        } else {
            fetchData();
        }
    }, [open, paginator, searchParams]);

    return (
        <PageHeader
            title="Issues"
            style={{ padding: '32px 24px 24px 0' }}
            footer={(
                <Space direction="vertical" size={24} style={{ width: '100%' }}>
                    {
                        item && (
                            <IssueDetail
                                item={item}
                                open={!!item}
                                loading={loading}
                                onClose={() => {
                                    setItem(null);
                                    searchParams.delete('open');
                                    setSearchParams(searchParams);
                                }}
                            />
                        )
                    }
                    <Filters
                        searchParams={searchParams}
                        startDate={startDate}
                        endDate={endDate}
                        handleDate={handleDate}
                        handleStatus={handleStatus}
                        handleIssueId={handleIssueId}
                        handleBooking={handleBooking}
                        handleWorkspace={handleWorkspace}
                        handleUnRead={handleUnRead}
                        handleType={handleType}
                    />
                    <IssuesTable
                        loading={loading}
                        data={data}
                        total={total}
                        paginator={paginator}
                        onPageChange={onPageChange}
                    />
                </Space>
            )}
        />
    );
};

export default Issues;
